import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import {
  updateEntitySchemaForAccountInactiveReasons,
  updateOdataOptionsForAccountInactiveReasons,
} from '../util/update-account-inactive-reason-property-for-filter';
import { initialize as initializeLabels, updateEntitySchemaForLabels, updateOdataOptionsForLabels } from '../util/update-label-property-for-filter';

export class BaseAccountsSchemaProcessor extends BaseSchemaProcessor {
  constructor(options, { propWhitelist, allowBiPattern = false }) {
    super(options);
    this.propWhitelist = propWhitelist;
    this.allowBiPattern = allowBiPattern;
    this.schemaI18nCampaign = options.schemaI18nCampaign;
    if (this.Permissions.IsAccountLabelsEnabled) {
      initializeLabels(options);
    }
  }

  // Abstract function to use in child's Processor if needed
  getOverridenSchemaProperties() {
    return {};
  }

  getAdditionalSchemaProperties() {
    return {};
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    const biPattern = /^(PoP)?PerformanceMetrics/;

    updatedSchema.properties = _.pick(
      updatedSchema.properties,
      prop => _.contains(this.propWhitelist, prop.property) ||
        (this.allowBiPattern && biPattern.test(prop.property))
    );

    updatedSchema.properties = {
      ...updatedSchema.properties,
      ...this.getAdditionalSchemaProperties(),
    };

    const overridenProperties = {
      // Common properties to override
      ...{
        Name: { title: this.i18n.getString('FilterLocalization_DataAttribute_AccountName') },
        AccountType: {
          chooseType: 'radio',
        },
      },
      // child properties to override
      ...this.getOverridenSchemaProperties(),
    };

    updatedSchema.properties = _.mapObject(updatedSchema.properties, (prop) => {
      Object.assign(prop, overridenProperties[prop.name]);

      return {
        ...prop,
        title: prop.title || this.i18n.getString(`FilterLocalization_DataAttribute_${_.result(prop.alias, 'legacy') || prop.originalProperty}`),
      };
    });

    updateEntitySchemaForAccountInactiveReasons(updatedSchema, this.schemaI18nCampaign, this.Permissions);
    if (this.Permissions && this.Permissions.IsAccountLabelsEnabled) {
      updateEntitySchemaForLabels(updatedSchema, true);
    }

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);

    updateOdataOptionsForAccountInactiveReasons(odataOptions);

    if (this.Permissions && this.Permissions.IsAccountLabelsEnabled) {
      updateOdataOptionsForLabels(odataOptions, true);
    }
    return odataOptions;
  }
}
